import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IncidentNumbersComponent } from './incident-numbers.component';

const routes: Routes = [{ path: '', component: IncidentNumbersComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IncidentNumbersRoutingModule { }
